import BaseApi from './baseApi';
import INoticeOfLossDetail from '../models/INoticeOfLossDetail';
import IAuthentication from '../models/IAuthentication';
export default class OutboundsNoticeOfLossDetailApi extends BaseApi {
    idUser : string = "";
    constructor() {
        super("dataaccess", "NoticeOfLoss");
        let userFromStorage : IAuthentication = JSON.parse(sessionStorage.getItem('user') || '{}');
        this.idUser = userFromStorage.idPerson;
    }

    async GetOutboundsNoticeOfLossDetail(noticeOfLossDetailId : string) : Promise<INoticeOfLossDetail[]> {
        let json : string = this.getJsonRead(noticeOfLossDetailId);
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var outboundsNoticeOfLossDetail: INoticeOfLossDetail[] = [];
            outboundsNoticeOfLossDetail = response.data as INoticeOfLossDetail[];
            return outboundsNoticeOfLossDetail;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async SaveOutboundsNoticeOfLossDetail(outboundsNoticeOfLossDetail: INoticeOfLossDetail) : Promise<string> {
        const json = this.getJsonSave(outboundsNoticeOfLossDetail);
        const response = await this.api.post('save', json);
        if (!response) return "";
        if (response.isSuccess) {
            return response.data as string;
        } else {
            this.modelState = response.errorState;
        }

        return "";
    }

    async UpdateOutboundsNoticeOfLossDetail(outboundsNoticeOfLossDetail: INoticeOfLossDetail) : Promise<boolean> {
        const json = this.getJsonUpdate(outboundsNoticeOfLossDetail);
        const response = await this.api.post('save', json);
        return this.isSuccess(response);
    }

    async DeleteOutboundsNoticeOfLossDetail(id: string) : Promise<boolean> {
        const json = this.getJsonDelete(id);
        const response = await this.api.post('delete', json);
        return this.isSuccess(response);
    }

    private getJsonDelete(id: string) : any {
        const json = {
            "deleteMetadata": [{
                "Item1": "DeletedBy",
                "Item2": this.idUser
            }, {
                "Item1": "DeletedDate",
                "Item2": new Date()
            }],
            "table": "OutboundsNoticeOfLossDetail",
            "conditions": [{
                "Item1": "OutboundsNoticeOfLossDetail",
                "Item2": "id",
                "Item3": "=",
                "Item4": id
            }]
        };
        return json;
    }

    private getJsonSave(outboundsNoticeOfLossDetail: INoticeOfLossDetail) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "idNoticeOfLoss",
                "Item2": outboundsNoticeOfLossDetail.idNoticeOfLoss
            }, {
                "Item1": "idOutboundDeliveryNoteDetail",
                "Item2": outboundsNoticeOfLossDetail.idDeliveryNoteDetail
            }, {
                "Item1": "idListPallet",
                "Item2": outboundsNoticeOfLossDetail.idListPallet
            }, {
                "Item1": "idPallet",
                "Item2": outboundsNoticeOfLossDetail.idPallet
            }, {
                "Item1": "casesPerPallet",
                "Item2": outboundsNoticeOfLossDetail.casesPerPallet
            }, {
                "Item1": "goodsPerCase",
                "Item2": outboundsNoticeOfLossDetail.goodsPerCase
            }, {
                "Item1": "totalGoods",
                "Item2": outboundsNoticeOfLossDetail.totalGoods
            }, {
                "Item1": "Deleted",
                "Item2": 0
            }, {
                "Item1": "CreatedBy",
                "Item2": this.idUser
            }, {
                "Item1": "CreatedDate",
                "Item2": new Date()
            }],
            "table": "OutboundsNoticeOfLossDetail"
        };
        return json;
    }

    private getJsonUpdate(outboundsNoticeOfLossDetail: INoticeOfLossDetail) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "idNoticeOfLoss",
                "Item2": outboundsNoticeOfLossDetail.idNoticeOfLoss
            }, {
                "Item1": "idOutboundDeliveryNoteDetail",
                "Item2": outboundsNoticeOfLossDetail.idDeliveryNoteDetail
            }, {
                "Item1": "idListPallet",
                "Item2": outboundsNoticeOfLossDetail.idListPallet
            }, {
                "Item1": "idPallet",
                "Item2": outboundsNoticeOfLossDetail.idPallet
            }, {
                "Item1": "casesPerPallet",
                "Item2": outboundsNoticeOfLossDetail.casesPerPallet
            }, {
                "Item1": "goodsPerCase",
                "Item2": outboundsNoticeOfLossDetail.goodsPerCase
            }, {
                "Item1": "totalGoods",
                "Item2": outboundsNoticeOfLossDetail.totalGoods
            }, {
                "Item1": "ModifiedBy",
                "Item2": this.idUser
            }, {
                "Item1": "ModifiedDate",
                "Item2": new Date()
            }],
            "table": "OutboundsNoticeOfLossDetail",
            "keyvalue": outboundsNoticeOfLossDetail.id
        };
        return json;
    }

    private getJsonRead(noticeOfLossId : string) : any {
        const json = {
            "fields": [{
                "Item1": "OutboundsNoticeOfLossDetail",
                "Item2": "id"
            }, {
                "Item1": "OutboundsNoticeOfLossDetail",
                "Item2": "idNoticeOfLoss"
            }, {
                "Item1": "OutboundsNoticeOfLossDetail",
                "Item2": "idOutboundDeliveryNoteDetail as idDeliveryNoteDetail"
            }, {
                "Item1": "OutboundsNoticeOfLossDetail",
                "Item2": "idListPallet"
            }, {
                "Item1": "ListPalletTypes",
                "Item2": "name as listPalletName"
            }, {
                "Item1": "OutboundsNoticeOfLossDetail",
                "Item2": "idPallet"
            }, {
                "Item1": "OutboundsNoticeOfLossDetail",
                "Item2": "casesPerPallet"
            }, {
                "Item1": "OutboundsNoticeOfLossDetail",
                "Item2": "goodsPerCase"
            }, {
                "Item1": "OutboundsNoticeOfLossDetail",
                "Item2": "totalGoods"
            }],
            "tables": [{
                "Item1": "OutboundsNoticeOfLossDetail"
            }, {
                "Item1": "ListPalletTypes"
            }],
            "joins": [{
                "Item1": "OutboundsNoticeOfLossDetail",
                "Item2": "idListPallet",
                "Item3": "ListPalletTypes",
                "Item4": "Id"
            }],
            "conditions": [{
                "Item1": "OutboundsNoticeOfLossDetail",
                "Item2": "Deleted",
                "Item3": "=",
                "Item4": "0",
                "Item5": "AND"
            }, {
                "Item1": "OutboundsNoticeOfLossDetail",
                "Item2": "idNoticeOfLoss",
                "Item3": "=",
                "Item4": noticeOfLossId
            }]
        };
        return json;
    }
}
